import React from "react";
import useAuth from "./useAuth";


export const LoginSuccess=()=>{

 const { onLoginSuccess } = useAuth();
    React.useEffect(() => {
        onLoginSuccess();
    }, []);

    return <div id="login-success"></div>

}